import axios from "axios";

class MiscServices {

  axios = axios.create({
    timeout: 30000
  });


  async getTaxInvoiceData(url) {
    try {
      const config = {
        method: 'POST',
        url: "https://asia-southeast2-autotrimitra.cloudfunctions.net/otodis__taxActivityGCF/misc/bridging/tax-link",
        json: true,
        data: {
          link_tax_invoice: url
        }
      }
      return await this.axios(config);
    } catch (e) {
      return e.response.data;
    }
  }

  async uploadAnalizeMultiNotice(data) {
    // HARDCODE for testing - remove when ready for production
    // return {
    //   data: {
    //     success: true,
    //     message: "Upload berhasil. Scan AI sedang diproses (PENDING). Gunakan batch_id untuk mengecek hasil.",
    //     data: {
    //       batch_id: "batch_6a1c431dca388190964d574d57fc9a42",
    //       batch_status: "validating",
    //       image_count: 2,
    //       vehicle_count: 2,
    //       log: {
    //         JMH2E1892666: [
    //           { key: "JMH2E1892666", time: "21:18", desc: "Processing Scanning File", hidden: false }
    //         ],
    //         KFE1E1528683: [
    //           { key: "KFE1E1528683", time: "21:18", desc: "Processing Scanning File", hidden: false }
    //         ]
    //       }
    //     },
    //     meta: {}
    //   }
    // };
    // END HARDCODE
    try {
      const config = {
        method: 'POST',
        url: "https://35tt91zxme.execute-api.ap-southeast-1.amazonaws.com/otodis/ai/ocr-document/batch/create",
        data: data
      }
      return await this.axios(config);
    } catch (e) {
      console.error("uploadAnalizeMultiNotice error:", e?.response || e);
      const serverMsg =
        e.response?.data?.error?.message ||
        e.response?.data?.message ||
        (typeof e.response?.data?.error === "string" ? e.response.data.error : null) ||
        (typeof e.response?.data === "string" ? e.response.data : null);

      if (e.response?.status === 413) {
        throw new Error(serverMsg || "Upload gagal, file terlalu besar");
      }

      throw new Error(serverMsg || e.message || "Terjadi kesalahan saat mengunggah file");
    }
  }


  async getMultiUploadNoticeLog(params = {}) {
    try {
      const config = {
        method: "GET",
        url: "https://35tt91zxme.execute-api.ap-southeast-1.amazonaws.com/otodis/ai/ocr-document/logs",
        json: true,
        params,
      }
      return await this.axios(config);
    } catch (e) {
      console.error("getMultiUploadNoticeLog error:", e?.response || e);
      const serverMsg =
        e.response?.data?.error?.message ||
        e.response?.data?.message ||
        (typeof e.response?.data?.error === "string" ? e.response.data.error : null) ||
        e.message;
      throw new Error(serverMsg || "Gagal mengambil log upload");
    }
  }
}

export const miscservices = new MiscServices();
